/**
 * Product Testing Animations Manager
 * Handles section scroll reveals & buy box entrance cascading animations
 */
class PtAnimationsManager {
  constructor() {
    this.isDesignMode = window.Shopify && window.Shopify.designMode;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.init();
  }

  init() {
    if (this.prefersReducedMotion || this.isDesignMode) {
      this.revealAllInstantly();
      if (this.isDesignMode) {
        document.addEventListener('shopify:section:load', (e) => this.revealSectionInstantly(e.target));
      }
      return;
    }

    this.setupStaggerIndexes();
    this.setupIntersectionObserver();
    this.triggerImmediateSections();
  }

  revealAllInstantly() {
    document.querySelectorAll('[data-pt-animate]').forEach(section => {
      section.classList.add('is-visible');
    });
  }

  revealSectionInstantly(section) {
    if (section && section.hasAttribute('data-pt-animate')) {
      section.classList.add('is-visible');
    } else if (section) {
      const animatedSection = section.querySelector('[data-pt-animate]');
      if (animatedSection) animatedSection.classList.add('is-visible');
    }
  }

  setupStaggerIndexes() {
    document.querySelectorAll('[data-pt-animate]').forEach(section => {
      const items = section.querySelectorAll('[data-pt-animate-item]');
      items.forEach((item, index) => {
        item.style.setProperty('--stagger-index', index);
      });
    });
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.12
    };

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, options);

    document.querySelectorAll('[data-pt-animate]:not([data-pt-animate="buybox"])').forEach(section => {
      this.observer.observe(section);
    });
  }

  triggerImmediateSections() {
    // Buy box and above-the-fold sections trigger entrance animation immediately
    const buyboxSections = document.querySelectorAll('[data-pt-animate="buybox"]');
    buyboxSections.forEach(section => {
      // Small timeout ensures styles are computed and initial opacity:0 is active before adding class
      requestAnimationFrame(() => {
        setTimeout(() => {
          section.classList.add('is-visible');
        }, 50);
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new PtAnimationsManager());
} else {
  new PtAnimationsManager();
}
